import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarForm()
		{
			
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{				
						case 'afiliadoFtn' :
							this.getBackendData=true
							let totalAfl = 0
							this.resetDataForm({state: 'servicios_activos'}) 

							for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
							{
								if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && this.dataMultiple[this.namePath].multiple_servicios[i].name!='Administración')
								{				
									let newValue= this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
									totalAfl=totalAfl+this.dataMultiple[this.namePath].multiple_servicios[i].valor
									if(newValue.id_afiliacion_registro===null)
									{
										newValue.id_afiliacion_registro=this.id_afiliacion_registro
									}
									if(newValue.id_info_ingresos===null)
									{
										newValue.id_info_ingresos=0
									}
									this.pushDataForm({state:  'servicios_activos', data: newValue})										
								}   
							}
							let aporteRegistrado = await this.getData({route: 'get_aporteregistrado', data: {razon: this.dataForm[this.namePath].info_afiliacion.id_datos_razon, afiliado: this.dataForm[this.namePath].datos_afiliado.id, mes: this.dataForm[this.namePath].info_afiliacion.mes_periodo,ano: this.dataForm[this.namePath].info_afiliacion.ano_periodo}})
							
							if(aporteRegistrado.archivo_plano===null)
							{
								await this.updateGlobal({state: 'openModal/modal',  data: 
									{ value: true, title: 'Registrar Aporte', modal: 'Aportes', loaded: false, data: {mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id} } })
							}
							else 
							{
								this.showAporteRegistrado=true
								this.linkaporte=this.url+'/api/pdf/registroaportes?id='+aporteRegistrado.archivo_plano.id_info_aportes.toString()+'&token='+this.token				
						
							}
							this.getBackendData=false
							return true
						break
						case 'aportesFtn': 
							await this.updateDataPost({ data: {
								data: [],
								tablaPost:['info_aportes','datos_afiliado','info_afiliacion','aportes_registro','servicios_activos'],
								tablaDelete: [],
								tablaAuditar: true, 
								route: 'save_all'
							}})
						break					

					}
				}

				let dataSave = await this.save(event.save,event.savePost)
				
				if(dataSave.error===false)
				{				
					if(event.ftn!==undefined)
					{
						switch(event.ftn)
						{
							case 'aportesFtn':	
								window.open( this.url+'/api/pdf/registroaportes?id='+dataSave.ids.info_aportes.toString()+'&token='+this.token,'_blank')				
							break;
							case 'aportesGrupalFtn':	
								window.open( this.url+'/api/pdf/registroaportes?id='+dataSave.ids.info_aportes.toString()+'&token='+this.token,'_blank')				
							break;
						}
					}
					
					if(event.ftn!=='editarAportesFtn')
					{
						await this.limpiarSearchs()	
					}
					
					const await01 = this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
					const await02 = this.resetDataIndex()
					const await03 = this.resetGlobal({state: 'openModal'})
					const await04 = this.resetGlobal({state: 'saveConfig/capa'})
					const await05 = this.resetDataForm()
					const await06 = this.onInit()

					await Promise.all([await01,await02,await03,await04,await05,await06])

					return true
				}
				else 
				{					
					const await00 = this.resetGlobal({state: 'saveConfig/capa'})
					const await01 = this.resetDataPost({state: 'data'}) 
					await Promise.all([await00,await01])
				}
			}
			catch(e){
				console.log('error save aportes registro')
			}			
		}		
	},
}
